export const hipMovePassiveText = {
  values: [
    { value: 'HipMovePassive', text: 'Ja', score: 1 },
    { value: 'HipMovePassive', text: 'Nei', score: 0 },
  ],
};
